import Link from 'next/link'
import { useDispatch, useSelector } from 'react-redux'
import { useIsMobile } from '../../hooks/useIsMobile'
import { gotoLogIn } from '../../redux/actions/AuthActions'
import { setFilterInfoModalVisible } from '../../redux/communityReducers/PostActionsReducer'
import { getUsername } from '../../utils/getUsername'
import { noImageFeed } from '../../utils/normalizedata'
import DesignCanvas from '../DesignCanvas'
import DesignHeader from '../DesignDetail/DesignHeader'
import InspirationActionsMenu from '../InspirationActionsMenu'
import CommentBtn from '../social/CommentBtn'
import GiftBtn from '../social/GiftBtn'
import LikeBtn from '../social/LikeBtn'
import SocialContainer from '../social/SocialContainer'
import { AnimatedFilterTag } from './AnimatedFilterTag'
import { AvatarAccessory, InfoHeader, InspirationFeedTile, InspirationItemButtons, InspirationItemContainer, MobileBlock, UserAvatar, UserName, UserProfile } from './Feed.styles'

/* Individual Feed Item */
export const InspirationItem = ({ id, priority, urlSlug, url, refFn, type, user, savedList, sourcePost, likes, gifts, style, hideActionButton, location }) => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated)
  const dispatch = useDispatch()
  const isMobile = useIsMobile()

  const logInCheck = e => {
    if (!isAuthenticated) {
      e.preventDefault()
      dispatch(gotoLogIn())

      return false
    }
  }

  // Show simplified layout for non-authenticated users or design-detail location
  if ((!isAuthenticated && isMobile) || location === 'design-detail') {
    return (
      <InspirationFeedTile style={style}>
        <InspirationItemContainer ref={refFn} id={id}>
          <Link href={`/design/${urlSlug || id}`} passHref>
            <a>
              <DesignCanvas priority={priority} data={sourcePost} style={{ borderRadius: '10px' }} scalable={true} />
            </a>
          </Link>
          {/* Designer link visible for non-authenticated users */}
          <InfoHeader>
            <Link href={user?.uniqueDisplayName ? `/designer/${user.uniqueDisplayName}` : `/dm/${user.objectId}`} passHref>
              <UserProfile>
                <UserAvatar loading="lazy" src={user?.funAvatarImageUrl || user?.thumbProfileImageFile?.url || ''} alt={user.uniqueDisplayName} onError={noImageFeed} />
                {user?.funAccessoriesImageUrl && <AvatarAccessory alt="" src={user.funAccessoriesImageUrl} loading="lazy" />}
                <UserName>{getUsername(user)}</UserName>
              </UserProfile>
            </Link>
          </InfoHeader>
        </InspirationItemContainer>
      </InspirationFeedTile>
    )
  }

  return (
    <InspirationFeedTile style={style}>
      <MobileBlock>
        <DesignHeader data={sourcePost} id={sourcePost.objectId} savedList={savedList} inspirationType={type} hideActionButton={hideActionButton} />
      </MobileBlock>
      <InspirationItemContainer ref={refFn} id={id}>
        <Link href={`/design/${urlSlug || id}`} passHref>
          <a>
            <DesignCanvas priority={priority} data={sourcePost} />
          </a>
        </Link>
        <InfoHeader>
          <Link href={user?.uniqueDisplayName ? `/designer/${user.uniqueDisplayName}` : `/dm/${user.objectId}`} passHref>
            <UserProfile>
              <UserAvatar loading="lazy" src={user?.funAvatarImageUrl || user?.thumbProfileImageFile?.url || ''} alt={user.uniqueDisplayName} onError={noImageFeed} />
              {user?.funAccessoriesImageUrl && <AvatarAccessory alt="" src={user.funAccessoriesImageUrl} loading="lazy" />}
              <UserName>{getUsername(user)}</UserName>
            </UserProfile>
          </Link>
          <InspirationActionsMenu type={type} location={location || 'home'} inspirationId={id} savedList={savedList} sourcePost={sourcePost} />
        </InfoHeader>
        {sourcePost.animationInfo && (
          <AnimatedFilterTag
            onClick={() => {
              dispatch(
                setFilterInfoModalVisible({
                  visible: true,
                  post: sourcePost
                })
              )
            }}
            post={sourcePost}
          />
        )}
        <InspirationItemButtons>
          <LikeBtn postId={id} loc={location || 'home'} numLikes={likes} />
          <CommentBtn data={sourcePost} postId={id} loc={location || 'home'} commentsCount={sourcePost.numComments || '0'} noButton="nobutton" />
          <GiftBtn postId={id} loc={location || 'home'} numGifts={gifts} />
        </InspirationItemButtons>
      </InspirationItemContainer>
      <MobileBlock>
        <SocialContainer loc={location || 'home'} id={sourcePost.objectId} data={sourcePost} numLikes={likes} />
      </MobileBlock>
    </InspirationFeedTile>
  )
}
